/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { LogoWrapper, breakpoints } from '@coursera/cds-core';

import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

import _t from 'i18n!nls/xdp';

type Props = {
  image?: string | null;
  partnerName?: string;
};

const originalStyles = {
  image: css`
    max-width: 100%;
    height: 45px;
    ${breakpoints.down('sm')} {
      height: 36px;
    }
  `,
};

const redesignStyles = {
  image: css`
    max-width: 100%;
    height: 30px;
    ${breakpoints.down('sm')} {
      height: 30px;
    }
  `,
};

const HeroPartnerLogo = ({ image, partnerName }: Props) => {
  const { enableXDPRedesignPhase1, enableXDPRedesignHero } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignHero;

  if (!image) {
    return null;
  }

  const styles = enableXDPRedesign ? redesignStyles : originalStyles;

  return (
    <LogoWrapper>
      <Imgix src={image} alt={partnerName || _t('Partner')} maxHeight={45} css={styles.image} />
    </LogoWrapper>
  );
};

export default HeroPartnerLogo;
